<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from 'echarts'
import resize from './mixins/resize'
import { mapGetters } from 'vuex'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
      default: '350px',
    },
    travelRegion: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    travelRegion: {
      deep: true,
      handler(val) {
        if (val) {
          let names = this.travelRegion.map(function (value, index, array) {
            return value.name
          })
          this.setOptions(val, names)
        }
      },
    },
  },
  created() {
    let names = this.travelRegion.map(function (value, index, array) {
      return value.name
    })
    this.names = names
  },
  computed: {
    ...mapGetters(['device']),
  },
  data() {
    return {
      chart: null,
      names: [],
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      let vm = this
      this.chart = echarts.init(this.$el, null, {
        renderer: 'canvas',
        useDirtyRect: false,
      })

      this.setOptions(this.travelRegion, this.names)
    },
    setOptions(travelRegion, names) {
      var option
      option = {
        title: {
          text: '旅遊國家統計',
          x: 'left',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        legend: {
          left: 'center',
          bottom: '10',
          data: names,
        },
        toolbox: {
          show: false,
          feature: {
            mark: { show: true },
            dataView: { show: true, readOnly: false },
            restore: { show: true },
            saveAsImage: { show: true },
          },
        },
        series: [
          {
            radius: this.device == 'mobile' ? '30%' : '60%',
            center: ['50%', '40%'],
            //center: ["50%", "39%"],
            //radius: [15, 95],
            name: '旅遊國家統計',
            type: 'pie',

            roseType: 'area',
            itemStyle: {
              borderRadius: 8,
            },
            data: travelRegion,
            color: [
              '#3694FF',
              '#FFB94F',
              '#FF3B3B',
              '#A16A17',
              '#3422FF',
              '#44D600',
              '#FF9100',
              '#985B00',
              '#2F5CFF',
              '#FFC107',
            ],
            animationEasing: 'cubicInOut',
            animationDuration: 2600,
          },
        ],
      }

      if (option && typeof option === 'object') {
        this.chart.setOption(option)
      }

      window.addEventListener('resize', this.chart.resize)
    },
    initChart2_beforeVersion() {
      let vm = this
      this.chart = echarts.init(this.$el, 'macarons')

      this.chart.setOption({
        title: {
          text: '旅遊國家統計',
          x: 'left',
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        legend: {
          left: 'center',
          bottom: '10',
          data: vm.names,
        },
        series: [
          {
            name: 'WEEKLY WRITE ARTICLES',
            type: 'pie',
            roseType: 'radius',
            radius: [15, 95],
            center: ['50%', '38%'],
            data: vm.travelRegion,
            // data: [
            //   { value: 20, name: "亞洲" },
            //   { value: 60, name: "美洲" },
            //   { value: 50, name: "歐洲" },
            //   { value: 10, name: "非洲" },
            // ],
            animationEasing: 'cubicInOut',
            animationDuration: 2600,
          },
        ],
      })
    },
  },
}
</script>
